import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { IconAI } from 'Icons';
import * as config from 'config';

export default class AdaptiveProcessingModal extends Component {
  state = {
    show: false,
    name: '',
    progress: 0,
  };

  componentDidMount() {
    window.addEventListener('adaptiveProcessing', this.handleEvent);
  }

  componentWillUnmount() {
    window.removeEventListener('adaptiveProcessing', this.handleEvent);
    this.clearInterval();
  }

  handleEvent = (e) => {
    const { action, name, progress, redirect } = e.detail || {};
    if (action === 'start') {
      this.setState({ show: true, name: name || '', progress: 5 }, () => {
        this.startInterval();
      });
    } else if (action === 'update') {
      this.setState({ progress: progress });
    } else if (action === 'end') {
      this.setState({ progress: 100 });
      setTimeout(() => {
        this.setState({ show: false, progress: 0, name: '' });
        if (redirect) {
          try {
            window.location.href = config.ROUTES.TestCreation;
          } catch (err) {
            // fallback
            window.location = config.ROUTES.TestCreation;
          }
        }
      }, 600);
      this.clearInterval();
    }
  };

  startInterval = () => {
    this.clearInterval();
    this.interval = setInterval(() => {
      this.setState((prev) => {
        if (prev.progress >= 90) {
          clearInterval(this.interval);
          return prev;
        }
        return { progress: prev.progress + 10 };
      });
    }, 700);
  };

  clearInterval = () => {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  };

  render() {
    const { show, name, progress } = this.state;
    if (!show) return null;
    return (
      <Modal
        show
        backdrop="static"
        keyboard={false}
        centered
        size="sm"
        className="ai-processing-modal"
        dialogClassName="ai-processing-modal-dialog"
        style={{ zIndex: 9999 }}
      >
        <Modal.Header>
          <button
            type="button"
            className="close"
            onClick={() => this.setState({ show: false, progress: 0, name: '' })}
            style={{
              position: 'absolute',
              right: '15px',
              top: '10px',
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#999',
              lineHeight: '1',
              opacity: 0.7,
              transition: 'opacity 0.2s',
            }}
            onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
            onMouseLeave={(e) => e.currentTarget.style.opacity = '0.7'}
            aria-label="Close"
          >
            ×
          </button>
        </Modal.Header>
        <Modal.Body className="ai-processing-modal-body">
          <div className="ai-processing-container">
            <div className="ai-processing-icon">
              <IconAI className="ai-icon-animated" />
            </div>
            <h4 className="ai-processing-title">Creating Adaptive Assessment</h4>
            {name && <p className="ai-course-name">{name}</p>}
            <div className="progress-circle-container">
              <div className="progress-circle">
                <svg className="progress-ring" width="120" height="120">
                  <circle className="progress-ring-circle-bg" cx="60" cy="60" r="54" />
                  <circle
                    className="progress-ring-circle"
                    cx="60"
                    cy="60"
                    r="54"
                    style={{
                      strokeDasharray: `${2 * Math.PI * 54}`,
                      strokeDashoffset: `${2 * Math.PI * 54 * (1 - progress / 100)}`,
                    }}
                  />
                </svg>
                <div className="progress-text">
                  <span className="progress-number">{Math.round(progress)}%</span>
                </div>
              </div>
            </div>
            <div className="ai-status">
              {progress < 80 ? (
                <p>Preparing adaptive assessment…</p>
              ) : progress < 100 ? (
                <p>Finalizing configuration…</p>
              ) : (
                <p className="success">✨ Complete!</p>
              )}
            </div>
            {progress < 100 && <p className="ai-time-estimate">This may take up to a minute</p>}
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}
